module.exports = __webpack_public_path__ + "img/ts24.310129c1.png";